import React from "react";
import PropTypes from "prop-types";
import marked from "marked";

import { renderToStaticMarkup } from "react-dom/server";

function Figure(props) {
  const { href, title, text } = props;
  return (
    <figure>
      <img src={href} alt={text} />
      <figcaption>{title}</figcaption>
    </figure>
  );
}

Figure.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

function Image(props) {
  const { href, title, text } = props;
  return <img src={href} title={title} alt={text} />;
}

Image.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default function (content, options = { baseUrl: "" }) {
  const renderer = new marked.Renderer();

  renderer.image = function (href, title, text) {
    return renderToStaticMarkup(<Figure href={options.baseUrl + href} title={title} text={text} />);
  };

  const markedOptions = {
    renderer,
  };

  return new Promise(function (resolve, reject) {
    marked(content, markedOptions, (err, html) => {
      if (err) {
        reject(err);
      } else {
        resolve(html);
      }
    });
  });
}
